import { useMutation } from "@tanstack/react-query"
import { createRfq, type CreateRfqPayload } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export function useCreateRfq() {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useMutation({
    mutationFn: (payload: CreateRfqPayload) => {
      if (!accessToken) throw new Error("Not authenticated")
      return createRfq(payload, accessToken)
    },
    onError: (error: Error) => {
      console.error("RFQ creation failed:", error.message)
    },
  })
}
